import type { RecommendationContext } from "@memorang/types";
import type {
	ContextRecommendedSession,
	EffectiveMastery,
	FullCell,
	RecommendationPurpose,
	SessionExplanationContext,
} from "../contract/recommendation-context-types";

export const purposeFor = ({
	mode,
	cell,
	minimumEvidence,
}: {
	mode: ContextRecommendedSession["mode"];
	cell: FullCell;
	minimumEvidence: number;
}): RecommendationPurpose => {
	if (mode === "MAINTENANCE") {
		return "MAINTAIN_MASTERY";
	}
	return cell.mastery.distinctItemCount < minimumEvidence
		? "BUILD_EVIDENCE"
		: "IMPROVE_MASTERY";
};

export const buildExplanationContext = ({
	cell,
	context,
	effective,
	purpose,
	requestedItemCount,
	actualItemCount,
}: {
	cell: FullCell;
	context: RecommendationContext;
	effective: EffectiveMastery;
	purpose: RecommendationPurpose;
	requestedItemCount: number;
	actualItemCount: number;
}): SessionExplanationContext => ({
	purpose,
	requestedItemCount,
	actualItemCount,
	dimensions: context.axes.map((axis) => {
		const valueId = cell.coordinates[axis.id];
		const value = axis.values.find(({ id }) => id === valueId);
		return {
			axisId: axis.id,
			axisTitle: axis.title,
			valueId,
			valueTitle: value?.title ?? String(valueId),
		};
	}),
	evidence: {
		observedRollingMastery: cell.mastery.value,
		effectiveMastery: effective.value,
		distinctItemCount: cell.mastery.distinctItemCount,
		minimumEvidence: context.policy.minimumEvidence,
		windowSize: 30,
		inferred: effective.inferred,
	},
});
